export default __webpack_public_path__ + "static/start_3-fcc69a4049c36fc1188c692609610900.png";